module.exports = __webpack_public_path__ + "img/zs2.1dca94f8.jpg";